module.exports = __webpack_public_path__ + "img/group_logo.dca6d4ef.png";